import { getStoryBySlug, StoryData } from '@cinch-nx/data-storyblok'
import { HomeStoryContent } from '../types/home-story-content'

export const getHomePageContentData = async (
  preview = false,
): Promise<StoryData<HomeStoryContent> | null> =>
  await getStoryBySlug<HomeStoryContent>('home', {
    version: preview ? 'draft' : 'published',
    resolve_relations: 'CarsCarousel.financeRepresentativeExample',
  })
